import CustomTableLayout from "../../../layouts/CustomTableLayout";
import AppHelmet from "../../../components/AppComponents/AppHelmet";
import useModule from "../../../hooks/useModule";
import ViewRecordDrawer from "../../../components/Drawers/Records/ViewRecordDrawer";
import { useCallback, useState } from "react";

const mainLayout = {
  id: "1",
  Fields: [
    "_RecordName",
    "User",
    "Action",
    "Description",
    "Metadata",
    "Created",
  ],
  ModuleAPIName: "SupportalLog",
  Type: "Table",
};

const query = {
  _SelectedLayout: "1",
  Fields: [
    "_RecordName",
    "User",
    "Action",
    "Description",
    "Metadata",
    "Created",
  ],
  Filters: [],
  OrderBy: {
    Field: "Created",
    Direction: "DESC",
  },
  Pagination: {
    Count: 25,
    Page: 1,
  },
};

const ActivityLog = () => {
  const { module } = useModule("SupportalLog");
  const [viewRecord, setViewRecord] = useState({
    open: false,
    recordID: "",
  });

  const handleOpenRecordName = useCallback((data: any) => {
    setViewRecord(() => ({ recordID: data.recordID, open: true }));
  }, []);

  if (!module) return null;

  return (
    <div className="tw:overflow-x-hidden">
      <AppHelmet title="Activity - GrowthCloud.com" />
      <CustomTableLayout
        title={"Activity Log"}
        description="Manage and track all supportal team activity"
        module={module}
        layout={mainLayout}
        initialQuery={query}
        recordNameField="_RecordName"
        creatable
        commentsWidget={false}
        onOpenRecordName={handleOpenRecordName}
        disableSave
      />
      {viewRecord.open && (
        <ViewRecordDrawer
          open={viewRecord.open}
          onClose={() => setViewRecord((prev) => ({ ...prev, open: false }))}
          recordID={viewRecord.recordID}
          module={module}
        />
      )}
    </div>
  );
};

export default ActivityLog;
